'use client';

import './instructor-card.less';

import { Brain, User } from 'lucide-react';
import { useToast } from '@/lib/hooks/use-toast';

export function InstructorCard() {
	const toast = useToast();

	return (
		<div className="instructor-card">
			<h4 className="instructor-card__heading">主讲导师</h4>

			<div className="instructor-card__profile">
				<div className="instructor-card__avatar">
					<User className="instructor-card__avatar-icon" />
				</div>
				<div>
					<p className="instructor-card__name">严博士</p>
					<p className="instructor-card__role">高级合伙人 · AI专家</p>
				</div>
			</div>

			<p className="instructor-card__bio">专注于人工智能领域研究与落地，深耕大模型应用、智能体架构与AI工作流设计，拥有丰富的AI产品与技术实践经验。</p>

			<button className="instructor-card__cta" onClick={() => toast.info('预约答疑功能即将上线，敬请期待')} type="button">
				预约答疑
			</button>

			<div aria-hidden="true" className="instructor-card__watermark">
				<Brain className="instructor-card__watermark-icon" />
			</div>
		</div>
	);
}
